exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tripla-scale-enter-active[data-v-1111ab82],.tripla-scale-leave-active[data-v-1111ab82]{transition:all .25s ease-in-out;transform:scale(1);opacity:1}.tripla-scale-enter[data-v-1111ab82],.tripla-scale-leave-to[data-v-1111ab82]{transform:scale(0);opacity:0}#tripla-chat-window[data-v-1111ab82]{transform:scale(0);opacity:0;transition:all .25s ease-in-out;transform-origin:bottom right}#tripla-chat-window.tripla-chat-window--show[data-v-1111ab82]{transform:scale(1);opacity:1}", ""]);

// exports
